import { useEffect, useState } from "react";
import {
  DeviceConnection,
  fetchDeviceConnections,
} from "../api/deviceConnection";

// Relecture périodique, au rythme où OpenVPN réécrit ses fichiers status.
const REFRESH_MS = 60_000;

/** État de connexion des produits visibles, indexé par uuid ; `{}` tant qu'il n'est pas chargé. */
export const useDeviceConnections = (): Record<string, DeviceConnection> => {
  const [connections, setConnections] = useState<
    Record<string, DeviceConnection>
  >({});
  useEffect(() => {
    let alive = true;
    const load = () =>
      fetchDeviceConnections().then((c) => {
        if (alive) setConnections(c);
      });
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);
  return connections;
};
